import request from '@/config/axios'

export interface AreaAgentLevelVO {
  id?: number
  name: string
  upgradeValue?: number
  levelSort: number
  isDefault: boolean
}

export interface AreaAgentLevelSimpleVO {
  id: number
  name: string
}

export const getAreaAgentLevelList = async () => {
  return await request.get<AreaAgentLevelVO[]>({ url: '/trade/area-agent/level/list' })
}

export const getAreaAgentLevelSimpleList = async () => {
  return await request.get<AreaAgentLevelSimpleVO[]>({
    url: '/trade/area-agent/level/list-all-simple'
  })
}

export const getAreaAgentLevel = async (id: number) => {
  return await request.get({ url: '/trade/area-agent/level/get', params: { id } })
}

export const createAreaAgentLevel = async (data: AreaAgentLevelVO) => {
  return await request.post({ url: '/trade/area-agent/level/create', data })
}

export const updateAreaAgentLevel = async (data: AreaAgentLevelVO) => {
  return await request.put({ url: '/trade/area-agent/level/update', data })
}

export const deleteAreaAgentLevel = async (id: number) => {
  return await request.delete({ url: '/trade/area-agent/level/delete', params: { id } })
}

export const setDefaultAreaAgentLevel = async (id: number) => {
  return await request.put({ url: '/trade/area-agent/level/set-default', params: { id } })
}
